var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import { css } from 'styled-components';
export var textLinkStyle = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-decoration: underline;\n  cursor: pointer;\n  font-weight: ", ";\n  color: ", ";\n  &:focus,\n  &:hover {\n    color: ", ";\n  }\n"], ["\n  text-decoration: underline;\n  cursor: pointer;\n  font-weight: ", ";\n  color: ", ";\n  &:focus,\n  &:hover {\n    color: ", ";\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.typography.font.weight.semibold;
}, function (_a) {
  var theme = _a.theme;
  return theme.tokens.accent.base.primary.regular;
}, function (_a) {
  var theme = _a.theme;
  return theme.tokens.accent.base.primary.strong;
});
var templateObject_1;